var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',[_vm._v("欢迎来到渠道管理系统")])])
}]

export { render, staticRenderFns }